module.exports = __webpack_public_path__ + "static/meta-legalaid-8f57ce0b3869146c4b885e09637f7a55.png";